import { inject } from '@angular/core';
import { ActivatedRoute, CanActivateFn, Router } from '@angular/router';

import { PaymentStatus } from '../enums/payment-status';
import { RouteString } from '../enums/route-string';
import { PlanActionsService } from '../store/actions';

export const orderStatusGuard: CanActivateFn = (route) => {
  const _router = inject(Router);
  const _activatedRoute = inject(ActivatedRoute);
  const _actions = inject(PlanActionsService);
  if (route.queryParams && route.queryParams['status'] !== undefined) {
    if (route.queryParams['status'] === PaymentStatus.Success) {
      _router.navigate(['/', route.params['lang'], RouteString.PAYMENT_SUCCESSFUL], {
        relativeTo: _activatedRoute,
        queryParamsHandling: 'merge',
        // change route without adding empty rout to the history (like redirectTo)
        replaceUrl: true,
      });
      return false;
    }
    _actions.paymentStatus(route.queryParams['status']);
  }

  return true;
};
